/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue';
import store from './store';
import routes from './router';
import VueRouter from 'vue-router';
import VeeValidate from 'vee-validate';
import VueResource from 'vue-resource';
import VeeValidateLaravel from 'vee-validate-laravel';
import RadioInput from "@/v3/components/fields/RadioInput.vue";
import CheckboxInput from "@/v3/components/fields/CheckboxInput.vue";
import TextInput from "@/v3/components/fields/TextInput.vue";
import EmailInput from "@/v3/components/fields/EmailInput.vue";
import PasswordInput from "@/v3/components/fields/PasswordInput.vue";
import DateInput from "@/v3/components/fields/DateInput.vue";
import GbpInput from "@/v3/components/fields/GbpInput.vue";
import NumberInput from "@/v3/components/fields/NumberInput.vue";
import Base64Input from "@/v3/components/fields/Base64Input.vue";
import TextAreaInput from "@/v3/components/fields/TextAreaInput.vue";
import DateSaturdayOnlyInput from "./components/Action/Fields/DateSaturdayOnlyInput";
import RatingsInput from "@/components/Action/Fields/RatingsInput";
import FilterableSelect from "@/v3/components/fields/FilterableSelect.vue";
import VueGtm from "vue-gtm";
import LabourArrayInput from "@/v3/components/fields/LabourArrayInput.vue";


import PortalVue from 'portal-vue'
import YearMonthDateInput from "@/components/Action/Fields/YearMonthDateInput.vue";
import ToggleInput from "@/v3/components/fields/ToggleInput.vue";
import * as VueGoogleMaps from 'vue2-google-maps'
import App from "../src/App";
import './assets/styles/index.css';
import './registerServiceWorker'
import Pusher from 'pusher-js';
import Siren from "super-siren";
import TimeInput from "@/components/Action/Fields/TimeInput.vue";
import MonthInput from "@/components/Action/Fields/MonthInput.vue";
import ArrayInput from "@/v3/components/fields/ArrayInput.vue";
import DateTimeInput from "@/components/Action/Fields/DateTimeInput.vue";

window.Vue = require('vue');
Vue.prototype.$eventBus = new Vue();
window.EventBus = new Vue();

Vue.use(PortalVue);
Vue.use(VeeValidate);
Vue.use(VueRouter);
Vue.use(VeeValidateLaravel);
Vue.use(VueResource);
Vue.component('radio-input', RadioInput);
Vue.component('toggle-input', ToggleInput);
Vue.component('checkbox-input', CheckboxInput);
Vue.component('alt-checkbox-input', CheckboxInput);
Vue.component('text-input', TextInput);
Vue.component('email-input', EmailInput);
Vue.component('password-input', PasswordInput);
Vue.component('textarea-input', TextAreaInput);
Vue.component('date-input', DateInput);
Vue.component('time-input', TimeInput);
Vue.component('number-input', NumberInput);
Vue.component('gbp-input', GbpInput);
Vue.component('base64-input', Base64Input);
Vue.component('date-saturday-only-input', DateSaturdayOnlyInput);
Vue.component('ratings-input', RatingsInput);
Vue.component('filterable-select-input', FilterableSelect);
Vue.component('month-input', MonthInput);
Vue.component('year-month-date-input', YearMonthDateInput);
Vue.component('array-input', ArrayInput);
Vue.component('date-time-input', DateTimeInput);
Vue.component('labour-array-input', LabourArrayInput);


var pusher = new Pusher('5a5cef98943e6740d5d1', {
    cluster: 'eu'
});

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBA-xgogrdWljPEwIUmONWdmweeYg7h35U',
        libraries: "places"
    },
});


Vue.mixin({
    methods: {
        getFrontendRouteFromApiRoute: function (apiRoute) {
            return apiRoute.replace(process.env.VUE_APP_API_URL + '/api', process.env.VUE_APP_BASE_URL);
        },
        getFrontendRouteWithoutHostFromApiRoute: function (apiRoute) {
            return apiRoute.replace(process.env.VUE_APP_API_URL + '/api', '');
        },
    },
});

const router = new VueRouter({
  routes,
  mode: 'history'
});


Vue.use(VueGtm, {
    id: "GTM-N7XT4VB",
    vueRouter: router
});

function isAuthenticated (store) {
    return store.getters.getAccessToken !== null;
}
async function hasClientAdminAcceptedTerms(store){
    let follow = Siren.Helper.follow;

    await Siren.Client.addHeader("Authorization", `Bearer ${store.getters.getAccessToken}`);
    let result = false;
    await Siren.get(process.env.VUE_APP_API_URL + "/api/")
        .then(
            follow('client')
        ).then(res => {
        let siren = res.body;
        let termsAndConditionsAction = siren.findActionByName('terms-and-conditions');
        if (termsAndConditionsAction !== null) {
            result = false;
            return;
        }
        result = true;
        return;
    }, this, result)
        .catch(error => {
            result = true;
        });
    return result;
}

async function hasNonClientAdminAcceptedTerms(store){
    let follow = Siren.Helper.follow;

    await Siren.Client.addHeader("Authorization", `Bearer ${store.getters.getAccessToken}`);
    let result = false;
    await Siren.get(process.env.VUE_APP_API_URL + "/api/")
        .then(
            follow('client')
        ).then(res => {
            let siren = res.body;
            let termsAndConditionsAction = siren.findActionByName('terms-and-conditions');
            if (termsAndConditionsAction === null){
                let notAcceptedLink = siren.findLinkByRel('terms-not-accepted')
                if(notAcceptedLink !== null){
                    result = false;
                    return;
                }
            }
            result = true;
        }, this, result)
        .catch(error => {
            result = true;
        });
    return result;
}

function isVerified(store){
    return store.getters.getUser?.is_verified || (store.getters.getUser?.email_verified_at !== null && store.getters.getUser?.email_verified_at !== undefined) ||
        (store.getters.getUser?.created_before_verification === undefined || store.getters.getUser?.created_before_verification === null || store.getters.getUser?.created_before_verification == 1);
}

router.beforeEach(async (to, from, next) => {

  document.title = `${to.meta.title} - Companies Management Systems`;
  if (to.name !== 'Login' && to.name !== 'OnSiteIdLogin' && to.name !== 'OnSiteIdRegister' && to.name !== 'OnSiteIdForgotPassword' && to.name !== 'SignUp'  && to.name !== 'Register' && to.name !== 'ViewOnSiteId' && to.name !== 'SignUpSuccess' && to.name !== 'Induction' && to.name !== 'ForgotPassword' && to.name !== 'ResetPassword' && to.name !=='Onboarding' && !isAuthenticated(store) && !to.fullPath.startsWith('/files/quotes/') && to.name !== 'AppDownload' && to.name !== 'GoogleCallback') next({ path: '/Login', query: { redirect_to: to.fullPath } })
    if ((to.name === 'SignUp' || to.name === 'Induction') && isAuthenticated(store)) next({ name: 'Dashboard' })
        let redirectToTermsAndConditions = !await hasClientAdminAcceptedTerms(store);
        let redirectToTermsNotAccepted = !await hasNonClientAdminAcceptedTerms(store);
        if(isAuthenticated(store) && to.name !== 'Login' && to.name !== 'SignUp' && to.name !== 'SignUpSuccess' && to.name !== 'Terms And Conditions' && to.name !== 'Induction'
        && redirectToTermsAndConditions) next({ name: 'Terms And Conditions'})
     if(isAuthenticated(store) && to.name !== 'Login' && to.name !== 'SignUp' && to.name !== 'SignUpSuccess' && to.name !== 'Terms Not Accepted' && to.name !== 'Induction'
        && redirectToTermsNotAccepted )     next({ name: 'Terms Not Accepted'})
    if(!redirectToTermsAndConditions && !redirectToTermsNotAccepted && isAuthenticated(store) &&
        (to.name === 'Terms And Conditions' || to.name === 'Terms Not Accepted'  && to.fullPath !== 'docs'))next({ name: 'Dashboard' })
    if(isAuthenticated(store) && to.name === 'verify'){next();}
    if(!isVerified(store)  && isAuthenticated(store) && to.name !== 'verify' && to.name !== 'not-verified'){
        next({name: 'not-verified'});
    }
    if(isVerified(store)  && isAuthenticated(store) && (to.name !== 'verify' && to.name === 'not-verified')){next({name: 'Dashboard'})}

    // if(window.mobileCheck() && to.name === 'Dashboard') next({name: 'OnSiteIdDashboard'})
    // if(window.mobileCheck() && to.name === 'Login') next({name: 'OnSiteIdLogin'})
    // if(window.mobileCheck() && to.name === 'Register') next({name: 'OnSiteIdRegister'})
    next();
});

window.mobileCheck = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
};
window.mobileAndTabletCheck = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
};

const app = new Vue({
  router,
  store,
    render: h => h(App),
    data: {
        onLine: navigator.onLine,
        showBackOnline: false,
        messages: ['First message...'],
        quickActionActive: false
    },
    methods: {
        updateOnlineStatus(e) {
            const {
                type
            } = e;
            this.onLine = type === 'online';
        },
        init:function() {
            console.log('init');
            ThreeDeeTouch.configureQuickActions([
                {
                    type: 'add-delivery',
                    title: 'Record Delivery',
                    subtitle: 'Quickly record a delivery',
                    iconType: 'add'
                },
                {
                    type: 'add-order',
                    title: 'Create Order',
                    subtitle: 'Create a new order',
                    iconType: 'add'
                }
            ]);
        }
    },
    watch: {
        onLine(v) {
            if (v) {
                this.showBackOnline = true;
                setTimeout(() => {
                    this.showBackOnline = false;
                }, 3000);
            }
        }
    },
    mounted() {
      document.body.classList.add('h-full');
      document.getElementsByTagName('html')[0].classList.add('h-full');
        window.addEventListener('online', this.updateOnlineStatus);
        window.addEventListener('offline', this.updateOnlineStatus);
    },
    beforeDestroy() {
        window.removeEventListener('online', this.updateOnlineStatus);
        window.removeEventListener('offline', this.updateOnlineStatus);
    }
}).$mount('#app');
        document.addEventListener('deviceready', app.init);

document.addEventListener('deviceready', function () {
    ThreeDeeTouch.onHomeIconPressed = function (payload) {
        console.log('home icon pressed');
        if (payload.type == 'add-delivery') {
            app.quickActionActive = 'add-delivery';
        } else if (payload.type == 'add-order') {
            app.quickActionActive = 'add-order';
        }else {
            // hook up any other icons you may have and do something awesome (e.g. launch the Camera UI, then share the image to Twitter)
            console.log(JSON.stringify(payload));
        }
    }
}, false);

var channel = pusher.subscribe('my-channel');
channel.bind('my-event', function(data) {
    app.messages.push(JSON.stringify(data));
});

globalThis.Vue = Vue;

